@if (visible) {
<div class="modal-overlay" (click)="close()">
  <div
    class="modal-container"
    [ngClass]="type"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-header">
      <h2 class="modal-title">{{ title }}</h2>
      <app-close-button (onClick)="close()"></app-close-button>
    </div>
    <div class="modal-content">
      <div class="modal-icon-container" [ngClass]="type">
        @if (type === 'info') {
        <i class="bi bi-info-circle-fill"></i>
        } @if (type === 'error') {
        <i class="bi bi-exclamation-triangle-fill"></i>
        } @if (type === 'dude') {
        <i class="bi bi-question-circle-fill"></i>
        }
      </div>
      <p class="modal-paragraph">{{ paragraph }}</p>
    </div>
    <div class="modal-footer">
      @if (showCancelButton) {
      <button class="modal-button btn-neutral" (click)="cancel()">
        <i class="bi bi-x-lg me-2"></i>{{ cancelText }}
      </button>
      }
      <button
        class="modal-button confirm-button"
        [ngClass]="type"
        (click)="confirm()"
      >
        <i class="bi bi-check-lg me-2"></i>{{ confirmText }}
      </button>
    </div>
  </div>
</div>
}
